import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { getDetailedRecommendations, getPriorityLabel } from '../../utils/scoring';

const { FiCalendar, FiCheckSquare, FiClock } = FiIcons;

export default function ActionPlan({ sectionScores = [] }) {
  if (!sectionScores || sectionScores.length === 0) return null;

  const planningSections = sectionScores.filter(s => s.percentage < 80).slice(0, 4);
  
  const plan = planningSections.map((section, idx) => ({
    week: `Semana ${idx + 1}: ${section.title.replace(/ti/gi, 'TI')}`,
    tasks: getDetailedRecommendations(section.id),
    priority: getPriorityLabel(section.percentage)
  }));

  if (plan.length === 0) return null;

  return (
    <div className="mt-12 action-plan-container">
      <div className="bg-slate-900 text-white rounded-2xl p-8 shadow-2xl print:bg-white print:text-slate-900 print:border print:border-slate-300">
        <div className="action-plan-header flex flex-col md:flex-row md:items-center justify-between gap-4 mb-10">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center text-white shadow-lg shadow-blue-600/20">
              <SafeIcon icon={FiCalendar} className="text-2xl" />
            </div>
            <div>
              <h3 className="text-2xl font-bold">Plan de Acción Personalizado</h3>
              <p className="text-slate-400 text-sm print:text-slate-500">Próximos 30 días para fortalecer tu infraestructura.</p>
            </div>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-slate-800 rounded-lg border border-slate-700 no-print">
            <SafeIcon icon={FiClock} className="text-blue-400" />
            <span className="text-xs font-bold text-slate-300">Estimado: 2-4 horas / semana</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {plan.map((phase, idx) => (
            <div key={idx} className="bg-slate-800/40 print:bg-slate-50 p-6 rounded-xl border border-slate-700/50 print:border-slate-200 relative overflow-hidden flex flex-col h-full print-break-inside-avoid">
              <div className="flex justify-between items-start mb-4">
                <h4 className="font-extrabold text-lg text-blue-400 print:text-blue-700 leading-tight pr-12">{phase.week}</h4>
                <span className={`absolute top-0 right-0 px-3 py-1 text-[9px] font-black uppercase tracking-widest rounded-bl-lg ${
                  phase.priority === 'ALTA' ? 'bg-red-500 text-white' : 
                  phase.priority === 'MEDIA' ? 'bg-orange-500 text-white' : 'bg-blue-500 text-white'
                }`}>
                  {phase.priority}
                </span>
              </div>
              <ul className="space-y-4 flex-grow">
                {phase.tasks.map((task, tidx) => (
                  <li key={tidx} className="flex items-start gap-3 text-slate-300 print:text-slate-700 group">
                    <SafeIcon icon={FiCheckSquare} className="mt-1 text-emerald-400 print:text-emerald-600 flex-shrink-0" />
                    <span className="text-sm leading-relaxed">{task}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}